export const staticSite = process.env.REACT_APP_STATIC_SITE !== "false";

export const shopPhoneDisplay = "07901 301388";
export const shopPhoneInternational = "447901301388";
export const shopWhatsAppUrl = `https://wa.me/${shopPhoneInternational}`;
